








































































import Vue, { PropType } from 'vue';
import {
  Exhibitor,
  ExhibitorCompany as Company,
  firebase,
  calender,
} from 'mostra';

export default Vue.extend({
  name: 'GAccountTop',
  props: {
    exhibitor: {
      type: Object as PropType<Exhibitor>,
      required: true,
    },
    company: {
      type: Object as PropType<Company>,
      required: true,
    },
  },
  data() {
    return {
      password: '',
      newPassword: '',
      formatDateGMT: calender.formatDateGMT,
    };
  },
  methods: {
    async onChangePassword() {
      try {
        this.$loading(true);
        const user = firebase.auth().currentUser;
        if (user && this.$auth.email) {
          const credential = (firebase.EmailAuthProvider as any).credential(
            this.$auth.email,
            this.password,
          );
          await user.reauthenticateAndRetrieveDataWithCredential(credential);
          await user.updatePassword(this.newPassword);
          this.$success('パスワードを変更しました');
        }
      } catch (error: any) {
        this.$error('パスワードの変更に失敗しました', error);
      } finally {
        this.$loading(false);
      }
    },
  },
});
